import React from "react";
import { Row, Col } from "antd";
import ProfileItem from "./ProfileItem";
import profiles from "./profiles";

class ProfileList extends React.Component {
  render() {
    return (
      <div>
        {profiles.map(row => (
          <Row>
            {row.cols.map(profile => (
              <Col
                key={profile.id}
                md={{ span: 8 }}
                className="about_avatar_block_col"
                style={{
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <ProfileItem language={this.props.language} {...profile} />
              </Col>
            ))}
          </Row>
        ))}
      </div>
    );
  }
}

export default ProfileList;



// WEBPACK FOOTER //
// ./src/pages/About/ProfilesList.js